import { Injectable } from '@angular/core'
import { LeftNavStateService } from './../left-nav-state.service'
import { NavComponentItem, NavComponentPrimaryItem, NavComponentSecondaryItem } from './nav-component-item'

const PRIMARY_ITEM_BASE_CLASS: string = 'se-left-nav__primary-item'

@Injectable({providedIn: 'root'})
export class LeftNavItemClassService {
  public prevSelectedItem: NavComponentItem
  constructor(private leftNavStateService: LeftNavStateService) {
    // noop
  }

  public getPrimaryNavItemClasses(item: NavComponentPrimaryItem): string {

    let baseClass = PRIMARY_ITEM_BASE_CLASS
    const classes: string[] = []

    // the item is in the process of 'collapsing'
    if (this.leftNavStateService.itemIsCollapsing(item)) {
      return this.getCollapsingClass()
    }

    // the item is expanded ('drawer' is open, etc)
    if (this.leftNavStateService.itemIsExpanded(item)) {

      baseClass += '--expanded'

      // this section is expanded and its last secondary item is the selected state
      // to handle some special styling, we'll need to add a flag for this
      if (this.leftNavStateService.primaryItemHasLastSecondaryItemSelected(item)) {
        classes.push('se-left-nav__item-expanded-with-last-secondary-item-selected')
      }

    } else if (this.leftNavStateService.itemIsSelected(item)) {
      // the item is actually selected (we're at this route/url)
      this.updateAriaCurrent(item)
      baseClass += '--selected'
      this.prevSelectedItem = item
    }

    // the item is not selected, but one of its children is
    if (this.leftNavStateService.itemIsSelectedParent(item)) {
      classes.push('se-left-nav__item-with-selected-secondary-item')
    }

    classes.push(baseClass)
    return classes.join(' ')

  }

  public getSecondaryItemClass(secondaryNavItem: NavComponentSecondaryItem): string {

    let className = 'se-left-nav__secondary-item'
    if (this.leftNavStateService.itemIsSelected(secondaryNavItem)) {
      this.updateAriaCurrent(secondaryNavItem)
      className += '--selected'
      this.prevSelectedItem = secondaryNavItem
    }

    return className

  }

  public getCollapsingClass(): string {
    return `${PRIMARY_ITEM_BASE_CLASS}--collapsing`
  }

  public updateAriaCurrent(item: NavComponentItem) {
    if (this.prevSelectedItem) {
      document.getElementById(this.prevSelectedItem.domId)?.removeAttribute('aria-current')
    }
    if (item) {
      document.getElementById(item.domId)?.setAttribute('aria-current', 'page')
    }
  }

}
